/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Past_DueInputs */



/**
* | output |
* | --- |
* | "Past Due" |
*
* @param {Subscription_Past_DueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subscription_past_due = /** @type {((inputs?: Subscription_Past_DueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Past_DueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En retard de paiement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Überfällig")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scaduto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Просрочено")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vencido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("逾期")
	if (locale === "ja") return /** @type {LocalizedString} */ ("支払期限超過")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछला बकाया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Vencido")
	return /** @type {LocalizedString} */ ("Past Due")
});